import React from "react";
import { Modal, Col, Button } from "react-bootstrap";
import styled from "styled-components";

const ElevatedModal = styled(Modal)`
  z-index: 99999;
  font-family: "YEKAN-BAKH-MEDIUM";
  text-align: center;
`;

function DeletePrompt({
  title = "اخطار حذف",
  description = "آیا از حذف این آیتم مطمئن هستید؟",
  actionText = "حذف کن",
  mode ='warning', // mode -> warning || info
  isOpen,
  onClose,
  onActionTap,
  size = "sm",
  ...rest
}) {
  return (
    <ElevatedModal
      show={isOpen}
      size={size}
      centered
      animation={false}
      onHide={onClose}
      {...rest}
    >
      <Modal.Header closeButton>
        <Modal.Title className='w-100 d-flex justify-content-center align-items-center'>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={"row p-1"}>
          <Col md={12}>
            <p>{description}</p>
          </Col>
          <Col md={12}>
            <Button
              variant={mode === 'warning' ? 'danger' : 'success'}
              size={"lg"}
              onClick={() => onActionTap?.()}
              className={"w-100 mt-3"}
            >
              {actionText}
            </Button>
          </Col>
        </div>
      </Modal.Body>
    </ElevatedModal>
  );
}

export default DeletePrompt;
